var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
export var FastenCallbackMode;
(function (FastenCallbackMode) {
    FastenCallbackMode["LIVE"] = "live";
    FastenCallbackMode["TEST"] = "test";
})(FastenCallbackMode || (FastenCallbackMode = {}));
export var FastenCallbackEventType;
(function (FastenCallbackEventType) {
    FastenCallbackEventType["CONNECTION_PENDING"] = "patient.connection_pending";
    FastenCallbackEventType["CONNECTION_SUCCESS"] = "patient.connection_success";
    FastenCallbackEventType["CONNECTION_FAILED"] = "patient.connection_failed";
    FastenCallbackEventType["WIDGET_COMPLETE"] = "widget.complete";
})(FastenCallbackEventType || (FastenCallbackEventType = {}));
export class FastenLoaderService {
    constructor() {
        this.fastenLoadStarted = false;
        this.fastenJSLoaded = false;
        this.fastenCSSLoaded = false;
    }
    get fastenLoaded() {
        return this.fastenJSLoaded && this.fastenCSSLoaded;
    }
    loadFasten() {
        if (this.fastenLoadStarted)
            return;
        this.fastenLoadStarted = true;
        void this.loadFastenJS();
        void this.loadFastenCSS();
    }
    async loadFastenJS() {
        await this.loadModuleScript("https://cdn.fastenhealth.com/connect/v3/fasten-stitch-element.js");
        this.fastenJSLoaded = true;
    }
    async loadFastenCSS() {
        await this.loadCSS("https://cdn.fastenhealth.com/connect/v3/fasten-stitch-element.css");
        this.fastenCSSLoaded = true;
    }
    loadModuleScript(url) {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.type = "module";
            script.src = url;
            script.onload = () => {
                resolve();
            };
            script.onerror = () => {
                reject(new Error(`Failed to load script: ${url}`));
            };
            document.head.appendChild(script);
        });
    }
    loadCSS(url) {
        return new Promise((resolve, reject) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = url;
            link.onload = () => {
                resolve();
            };
            link.onerror = () => {
                reject(new Error(`Failed to load CSS: ${url}`));
            };
            document.head.appendChild(link);
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FastenLoaderService.prototype, "fastenJSLoaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FastenLoaderService.prototype, "fastenCSSLoaded", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FastenLoaderService.prototype, "fastenLoaded", null);
